module.exports = __webpack_public_path__ + "static/letters-to-a-young-poet-4cb838232323dd069ce8fff26562f032.jpg";